/**
 * Deterministic seeded-RNG primitives shared by every procedural map
 * generator. Keeping them in one place means a chart is a pure function
 * of its `(slug, variant)` seed across modes — the server re-derives the
 * identical chart for replay validation instead of persisting a blob.
 *
 * Both functions are platform-stable (integer math only, no `Math.random`),
 * so the same seed yields the same stream on the client and the server.
 */

/** FNV-1a string hash → 32-bit seed (stable across platforms). */
export function hashStringToSeed(str: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** mulberry32 PRNG — tiny, deterministic; one instance per seeded stream. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
